import { toLogin } from '../libs/login';
import { HEADER, OP_API_URL, CAST_VIEWER_URL } from '@/config/app';
import { getSubsystemToken, clearSubsystemToken } from './subsystem-token';

const SCORER_AUD = 'scorer';

function sendOnce(url, method, data, token) {
	const header = Object.assign({}, HEADER, { 'Authorization': 'Bearer ' + token });
	return new Promise((resolve, reject) => {
		uni.request({
			url: OP_API_URL + '/api/scorer-open/' + url,
			method: method || 'GET',
			header: header,
			data: data || {},
			success: (res) => resolve(res),
			fail: (err) => reject(err && err.errMsg ? err.errMsg : '网络请求失败')
		});
	});
}

function responseMessage(body, fallback) {
	if (!body) return fallback;
	return body.msg || body.message || fallback;
}

function isAuthRejected(body) {
	return body && [30007, 30008, 30012].indexOf(body.code) !== -1;
}

function isOk(body) {
	return body && (body.ok === true || body.code === 0);
}

function scorerRequest(url, method, data) {
	return new Promise((resolve, reject) => {
		getSubsystemToken(SCORER_AUD).then((token) => {
			sendOnce(url, method, data, token).then((res) => {
				if (isOk(res.data)) {
					resolve(res.data);
				} else if (isAuthRejected(res.data)) {
					clearSubsystemToken(SCORER_AUD);
					getSubsystemToken(SCORER_AUD, true).then((newToken) => {
						sendOnce(url, method, data, newToken).then((res2) => {
							if (isOk(res2.data)) {
								resolve(res2.data);
							} else if (isAuthRejected(res2.data)) {
								toLogin();
								reject(responseMessage(res2.data, '登录状态已失效'));
							} else {
								reject(responseMessage(res2.data, '请求失败'));
							}
						}).catch(reject);
					}).catch((e) => reject(e));
				} else {
					reject(responseMessage(res.data, '请求失败'));
				}
			}).catch(reject);
		}).catch((e) => reject(e));
	});
}

const scorerApi = {};
['get', 'post'].forEach((method) => {
	scorerApi[method] = (api, data) => scorerRequest(api, method.toUpperCase(), data);
});

export default scorerApi;
export { OP_API_URL as SCORER_API_URL, CAST_VIEWER_URL as SCORER_CAST_VIEWER_URL };
